import React from 'react';
import { Card } from 'components';

import ImportantStatusMobileView from './ImportantStatusMobileView';
import { useNavigate } from 'react-router-dom';

const MobileDashboard = ({ filters }) => {
    const navigate = useNavigate();


    return (
        <div className='w-full ' /* style={{height:'90vh'}} */>

            <div className='w-full ' style={{ height: '70vh' }}>
                <ImportantStatusMobileView filters={filters}></ImportantStatusMobileView>


            </div>


            <div className="flex-column mt-5 " style={{ height: '15vh', /* backgroundColor: 'red' */ }}>

                <Card
                    className="p-4 w-full flex justify-center"
                    style={{ backgroundColor: '#148baf', color: 'white', fontWeight: '700', fontSize: 18 }}
                    onClick={() => {
                        navigate('/create_incidents');
                    }}

                >REPORT INCIDENT</Card>

               <Card
                    className="p-4 w-full flex justify-center mt-4"
                    style={{ backgroundColor: '#ffa500', color: 'white', fontWeight: '700', fontSize: 18 }}
                    onClick={() => {
                        navigate('/my_audits');
                    }}

                >MY AUDITS</Card>

            </div>
        </div>
    );
};

export default MobileDashboard; 